export function request(id) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_FREEBET_CREDITS_REQUEST',
        id,
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_FREEBET_CREDITS_ERROR',
        errors,
        id,
    };
}

export function finish(id, data) {
    id = parseInt(id, 10);
    return {
        type: 'CUSTOMERS_GET_FREEBET_CREDITS_FINISH',
        id,
        data,
    };
}
